<template>
    <div class="email-broadcast-filter-toolbar">
        <CommonFilterTool
            v-model="emailBroadcastFilter"
            :keep-state-on-query-params="false"
            :filter-meta="filterMetas"
            :label-formatter="filterLabelFormatter"
            @clear-all="clearAllFilters"
        />
        <div class="active-filters">
            <div v-for="(filter, index) in emailBroadcastFilter" :key="index" class="active-filter-group">
                <div class="filter-wrapper-preview" @click="openFilter(filter.name)">
                    <span class="filter-value-text">{{ filterLabelFormatter(filter.name, filter.filterValue) }}</span>
                </div>
                <div class="clear-active-filter" @click="removeFilter(filter.name)">
                    <i class="material-icons">close</i>
                </div>
            </div>
            <div v-if="emailBroadcastFilter.length > 1" class="clear-active-filter" @click="clearAllFilters">
                {{ $t("ticket.ticketFilterList.clearAll") }}
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import CommonFilterTool from "../../Chatbot/pages/archive/CommonFilterTool.vue";

export default Vue.extend({
    components: {
        CommonFilterTool,
    },
    data() {
        return {
            emailBroadcastFilter: [],
            filterMetas: [
                {
                    name: "title",
                    label: "Title",
                    materialIcon: "title",
                    controlType: "input",
                    controlProps: {},
                    defaultValue: "",
                },
                {
                    name: "description",
                    label: "Description",
                    materialIcon: "description",
                    controlType: "input",
                    controlProps: {},
                    defaultValue: "",
                },
                {
                    name: "status",
                    label: "Status",
                    materialIcon: "info",
                    controlType: "select",
                    controlProps: {
                        options: [
                            { id: "scheduled", label: "Scheduled" },
                            { id: "created", label: "Created" },
                            { id: "queued", label: "Queued" },
                            { id: "running", label: "Running" },
                            { id: "completed", label: "Completed" },
                            { id: "failed", label: "Failed" },
                            { id: "cancelled", label: "Cancelled" },
                        ],
                    },
                    defaultValue: "",
                },
                // Diğer filtre alanları...
            ],
        };
    },
    methods: {
        openFilter(name) {
            const el = document.querySelector(`.filter-wrapper-preview[data-filter-name="${name}"]`);
            if (el) {
                el.click();
            }
        },
        removeFilter(name) {
            this.emailBroadcastFilter = this.emailBroadcastFilter.filter((x) => x.name !== name);
        },
        clearAllFilters() {
            this.emailBroadcastFilter = [];
        },
        filterLabelFormatter(name, value) {
            const filter = this.filterMetas.find((x) => x.name === name);
            if (filter.controlType === "select") {
                const option = filter.controlProps.options.find((x) => x.id === value);
                return `${filter.label}: ${option?.label || value}`;
            } else {
                return `${filter.label}: ${value}`;
            }
        },
    },
    watch: {
        emailBroadcastFilter: {
            handler: function () {
                this.$emit("input", this.emailBroadcastFilter);
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.email-broadcast-filter-toolbar {
    display: flex;
    width: 100%;

    .active-filters {
        display: flex;
        gap: 5px;
        overflow-x: auto;
        padding: 10px 0;
        overflow-y: hidden;

        &::-webkit-scrollbar {
            display: none;
        }

        .clear-active-filter {
            width: max-content;
            height: 30px;
            background-color: #000;
            color: #fff;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 7px;
            cursor: pointer;
        }

        .active-filter-group {
            display: flex;
            gap: 5px;
            height: 40px;
        }

        .filter-wrapper-preview {
            border-radius: 20px;
            padding: 1px 5px !important;
            background: white;
            color: black;
            border: 1px solid var(--color-border-default);

            .filter-value-text {
                font-size: 12px;
                font-weight: 600;
                color: #22272d;
                line-height: 24px;
            }
        }
    }
}
</style>
